import React, { FC } from 'react';
import { AccordionEventKey } from 'react-bootstrap/AccordionContext';
import { Accordion } from 'react-bootstrap';
import PunishmentHistoryForm from '../forms/punishment-history-form';
import { useDispatch, useSelector } from 'react-redux';
import { EducationHistoryModel, PunishmentHistoryModel } from '../../../../shared/models/employee.model';
import { handleEmployeeSectionAddNewData } from '../../../../shared/utils/function-state';
import SectionAddRow from '../section-add-row';
import {
    getCurrentEmployee,
    getCurrentEmployeeEditProfile,
    getEmployeeAction
} from '../../../../shared/services/employee-service';

interface PunishmentHistoryProps {
    defaultKey?: AccordionEventKey;
}

const EmployeePunishmentHistory: FC<PunishmentHistoryProps> = ({defaultKey = '0'}) => {
    const dispatch = useDispatch();
    const employee = useSelector(getCurrentEmployee);
    const employeeAction = useSelector(getEmployeeAction);

    const employeeEditProfile = useSelector(getCurrentEmployeeEditProfile);
    const haveSomeEditField = () => {
        if (employeeAction.type === 'view-edit-request') {
            const lengthNotSame = employee.punishment_histories.length !== employeeEditProfile.punishment_histories.length;

            if (lengthNotSame)
                return true;

            return employee.punishment_histories.some((data, index) => {
                return Object.keys(data).some(key => {
                    const kk = key as keyof PunishmentHistoryModel;
                    if (key === 'id' || key === 'employee_id' || key === 'created_at'  || key === 'updated_at' || key === 'from_id')
                        return false;
                    return employeeEditProfile.punishment_histories[index][kk] !== data[kk];
                });
            });
        }
        return false;
    };

    const onAddNewData = () => {
        const initData: PunishmentHistoryModel = {
            id: null,
            employee_id: null,
            date: null,
            name: null,
            order_no: null,
            file: null,
            new_file: true,
            file_name: '',
            from_id: null,
        };
        handleEmployeeSectionAddNewData('punishment_histories', initData, dispatch);
    };

    return (
        <Accordion defaultActiveKey={defaultKey} className="mt-3">
            <Accordion.Item eventKey="0">
                <Accordion.Header className={`text-mof-primary ${haveSomeEditField() ? 'accordion-warning' : ''}`}>
                    <h5 className="text-mof-primary m-0">ประวัติการลงโทษ</h5>
                </Accordion.Header>
                <Accordion.Body>
                    <PunishmentHistoryForm/>
                    <SectionAddRow onAddNewData={onAddNewData}/>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default EmployeePunishmentHistory;